<template>
  <div>
    <Card>
      <Tag size="large">
        中心点经纬度：[{{ circleObj.centerPointLongitude }}，{{ circleObj.centerPointLatitude }}，]，
        半径：{{ circleObj.radius }}m，
        中心点地址：{{ circleObj.address }}
      </Tag>
      <div style="position: relative">
        <div style="position: absolute;top: 5px;left:5px;z-index: 999">
          <span style="font-weight: bolder">{{ deptName }}</span>
        </div>
        <div id="bmap" style="width: 100%;height: 550px;margin-top: 0px"></div>
      </div>
    </Card>
  </div>
</template>

<script>
import { BMapLoader } from '@/utils/mapLoader'

export default {
  name: "rangeDetail",
  data() {
    return {
      deptName: '',
      searchPlace: null,
      searchLng: '',
      searchLat: '',
      circleRadius: 500,
      inspectorList: [],
      circleObj: {
        centerPointLongitude: '',
        centerPointLatitude: '',
        radius: 0,
        address: ''
      }
    }
  },
  mounted() {
    if (this.$route.query.id) {
      this.id = this.$route.query.id
      this.deptName = this.$route.query.deptName
      this.getRangInfo()
    }
  },
  methods: {
    getRangInfo() {
      this.$http.get(`/api/dutySignConfigs/${this.id}`).then(res => {
        console.log(res)
        if (res.status === 200) {
          this.circleObj.centerPointLatitude = res.data.centerPointLatitude
          this.circleObj.centerPointLongitude = res.data.centerPointLongitude
          this.circleObj.radius = res.data.radius
          this.initMap()
        }
      })
    },
    goBack() {
      this.$store.commit('app/closePage', {
        vm: this,
        fromName: this.$route.name,
        toName: 'signSet'
      })
    },
    handleClose(event, name) {
      // console.log(name)
      this.map.removeOverlay(this.circle);
      this.map.removeOverlay(this.marker);
      this.circleObj = null
    },
    initMap() {
      const _this = this
      BMapLoader(this.$mapSignRangeKey).then(BMap => {
        const map = new BMap.Map('bmap', { enableMapClick: false })
        _this.map = map
        _this.BMap = BMap
        map.disableKeyboard() // 禁用键盘操作地图
        map.enableScrollWheelZoom(true) // 开启鼠标滚轮缩放
        // 添加中心点和缩放等级，如果不添加，初始化出来页面为白屏
        map.centerAndZoom('德州市', 14)
        _this.geoCoder = new BMap.Geocoder()
        //标圆
        _this.showCircle({
          centerPointLongitude: _this.circleObj.centerPointLongitude,
          centerPointLatitude: _this.circleObj.centerPointLatitude,
          radius: _this.circleObj.radius
        })
      })
    },
    // 画圈
    showCircle(item) {
      if (!this.BMap) {
        // this.initMap()
        return
      }
      let radius = item.radius
      // 圆obj
      let circleObj = {}
      // circleObj.id = item.id
      // circleObj.isDelete = 0
      // circleObj.departmentId = this.deptId
      circleObj.radius = radius
      circleObj.centerPointLatitude = item.centerPointLatitude
      circleObj.centerPointLongitude = item.centerPointLongitude

      // 画圆
      var circle = new this.BMap.Circle(new this.BMap.Point(item.centerPointLongitude, item.centerPointLatitude), radius, {
        strokeColor: '#FF33FF',
        strokeWeight: 2,
        strokeOpacity: 0.5,
        fillOpacity: 0.4,
        strokeStyle: 'dashed',
        strokeDasharray: [10, 10],
        // 线样式还支持 'dashed'
        fillColor: '#1791fc',
        zIndex: 100
      })
      circleObj.circle = circle
      this.circle = circle

      this.marker = new this.BMap.Marker(new this.BMap.Point(item.centerPointLongitude, item.centerPointLatitude), {
        // offset: 0
      })
      this.map.addOverlay(this.marker)
      this.map.addOverlay(this.circle)
      // this.circle.enableEditing()
      this.mapViewAuto(new this.BMap.Point(item.centerPointLongitude, item.centerPointLatitude))

      const _this = this
      this.geoCoder.getLocation(new this.BMap.Point(item.centerPointLongitude, item.centerPointLatitude), function (rs) {
        // console.log(rs)
        circleObj.address = rs.address + rs.content.poi_desc
        _this.circleObj = { ...circleObj }
      })
      // console.log(this.circleObj)
    },
    mapViewAuto(point) {
      const centerPoint = this.map.getViewport([point])
      // 初始化地图，设置中心点坐标和地图级别
      this.map.centerAndZoom(centerPoint.center, 16)
    }
  }
}
</script>

<style scoped lang="less">
</style>
